import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        user: {
            id: 0,
            nick_name: '',
            head_image: '',
            signature: '何もない',
            user_level: 1,
            sex: 0,
            consecutive_live_days: 0,
            n_fans_count: 0,
            n_focus_count: 0,
            n_svideo_count: 0,
            n_diamonds: 0,
            n_ticket: 0
        },
        app: {
            isMaintenance: false,
            maintenanceMsg: '',
            appLogo: process.env.BASE_URL + 'images/logo.png',
            appName: 'ミーティアLive',
            iosDownloadUrl: '',
            androidFilename: '',
            qrcodeUrl: '',
            isShowLogin: false
        }
    },
    mutations: {
        setAppData(state, appInfo) {
            state.app.isMaintenance = (appInfo.is_maintenance == 1)
            state.app.maintenanceMsg = appInfo.maintenance_msg
            state.app.appLogo = appInfo.app_logo
            state.app.appName = appInfo.app_name
            state.app.iosDownloadUrl = appInfo.ios_down_url
            state.app.androidFilename = appInfo.android_filename
            state.app.qrcodeUrl = appInfo.qrcode_url
            state.app.isShowLogin = (appInfo.is_show_login == 1)
        },
        setUser(state, userInfo) {
            state.user.id = userInfo.id
            state.user.nick_name = userInfo.nick_name
            if(userInfo.head_image != null) {
                state.user.head_image = userInfo.head_image
            } else {
                state.user.head_image = process.env.BASE_URL + 'images/logo.png'
            }
            if(userInfo.signature != null) state.user.signature = userInfo.signature
            if(userInfo.user_level != null) state.user.user_level = userInfo.user_level
            if(userInfo.sex != null) state.user.sex = userInfo.sex
            if(userInfo.consecutive_live_days != null) state.user.consecutive_live_days = userInfo.consecutive_live_days
            if(userInfo.n_fans_count != null) state.user.n_fans_count = userInfo.n_fans_count
            if(userInfo.n_focus_count != null) state.user.n_focus_count = userInfo.n_focus_count
            if(userInfo.n_svideo_count != null) state.user.n_svideo_count = userInfo.n_svideo_count
            if(userInfo.n_diamonds != null) state.user.n_diamonds = userInfo.n_diamonds
            if(userInfo.n_use_diamonds != null) state.user.n_use_diamonds = userInfo.n_use_diamonds
            if(userInfo.n_ticket != null) state.user.n_ticket = userInfo.n_ticket
        }
    },
    actions: {
  
    }
})

export default store
